import { Link } from "react-router-dom";
import { useLanguage, CONTACT } from "@/i18n";
import LogoMark from "@/components/Logo";
import useMenu from "@/hooks/useMenu";

export default function Footer() {
  const { lang, t } = useLanguage();
  const menuItems = useMenu();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand text-white" data-testid="site-footer">
      <div className="container-editorial py-16 lg:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <div className="flex items-center gap-3">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-brand-linen" data-testid="footer-logo-badge">
              <LogoMark className="h-10 w-auto" />
            </span>
            <span className="font-serif text-2xl">Dott. Giovanni Angilè</span>
          </div>
          <p className="mt-5 max-w-sm text-sm font-light leading-relaxed text-white/70">
            {t.footer.tagline}
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/60">{t.footer.nav}</p>
          <ul className="mt-4 space-y-2.5 text-sm font-light">
            {menuItems.map((m) => (
              <li key={m.id}>
                <Link className="link-underline" to={m.path} data-testid={`footer-link-${m.key}`}>
                  {(lang === "en" && m.label_en) || m.label}
                </Link>
              </li>
            ))}
            <li><Link className="link-underline" to="/admin" data-testid="footer-link-admin">Admin</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/60">{t.footer.contacts}</p>
          <ul className="mt-4 space-y-2.5 text-sm font-light text-white/85">
            <li data-testid="footer-contact-phone">{CONTACT.phone}</li>
            <li data-testid="footer-contact-address">{CONTACT.address}, {CONTACT.city}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15">
        <div className="container-editorial py-6 flex flex-col md:flex-row gap-3 justify-between text-[11px] leading-relaxed text-white/50">
          <p className="max-w-xl">{t.footer.disclaimer}</p>
          <p>© {year} Dott. Giovanni Angilè — {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
